


















import Vue from 'vue'
import Vuex from 'vuex'
import AppState from '../AppState'

export default Vue.component('apartment', {
  computed: Vuex.mapState({
    currentView: function (state: AppState) { return state.currentView },
    characters: function (state: AppState) { return state.charactersInScene },
    jerry: function (state: AppState) { return state.characters.jerry },
  }),
  methods: {
    characterStyles: function (index: number, mood: string) {
      return {
        top: `${Math.random() * 100 / 16}em`,
        left: `${index * 120 / 16}em`,
      }
    }
  }
})
